// Generated by tools/scripting/generate_native_dialogue_predicate_data.py.
// Do not hand-edit; regenerate from verified predicate evidence.
export const NATIVE_DIALOGUE_PREDICATE_DATA = Object.freeze({
  "schema": "new-yokosuka-native-dialogue-predicate-data-v2",
  "generatedFrom": {
    "schema": "new-yokosuka-dialogue-predicate-values-v6",
    "executableSha256": "ca98879a97df87b668836bbfa597d38c6f9efc3fd45160208b8d5d866325f32c",
    "spatialTableSha256": "3f221dc8b2414408009c0596f891ede7d325b9cf3bf5843df1ea4957e3388ebe"
  },
  "runtimeComponentModes": {
    "0": "year since 1900",
    "1": "month, 1 through 12",
    "2": "day of month, 1 through 31",
    "3": "weekday, Sunday 0 through Saturday 6",
    "4": "hour, 0 through 23",
    "5": "minute, 0 through 59",
    "6": "persistent yen balance"
  },
  "calendar": {
    "runtimeAddress": "0xc225228",
    "byteLength": 7,
    "fields": [
      {
        "offset": 0,
        "name": "yearSince1900"
      },
      {
        "offset": 1,
        "name": "month",
        "range": "1..12"
      },
      {
        "offset": 2,
        "name": "dayOfMonth",
        "range": "1..31"
      },
      {
        "offset": 3,
        "name": "weekday",
        "range": "0..6",
        "zeroValue": "Sunday"
      },
      {
        "offset": 4,
        "name": "hour",
        "range": "0..23"
      },
      {
        "offset": 5,
        "name": "minute",
        "range": "0..59"
      },
      {
        "offset": 6,
        "name": "subMinuteTick",
        "predicateMode": null
      }
    ],
    "weekdayFormula": "(day + floor((13 * adjustedMonth + 8) / 5) + adjustedYear + floor(adjustedYear / 4) - floor(adjustedYear / 100) + floor(adjustedYear / 400)) mod 7",
    "weekdayAdjustment": "for January and February, add 12 to month and subtract 1 from year",
    "yearBase": 1900
  },
  "currency": {
    "runtimeStructureAddress": "0xc220a20",
    "runtimeStructureOffset": "0x18",
    "persistentValueSelector": 2,
    "scriptReadOperation": "0x005f",
    "scriptWriteOperation": "0x0060",
    "unit": "JPY",
    "independentEvidence": [
      "The native capsule-toy payment routine reads persistent selector 2, subtracts immediate 100, and writes selector 2.",
      "The vending affordability and MONEY_LOCK paths independently use selector 2 as their balance."
    ]
  },
  "stateBanks": {
    "resetRoutine": "0xc159290",
    "descriptorRoutine": "0xc158c72",
    "saveExportRoutine": "0xc09c854",
    "saveImportRoutine": "0xc09c8b4",
    "defaultState": "all bytes zero",
    "banks": [
      {
        "bank": 2,
        "storage": "bitfield",
        "runtimeAddress": "0xc223ef8",
        "capacity": 1024,
        "byteLength": 128,
        "reader": "0xc15904c",
        "writer": "0xc159076",
        "initialValue": 0,
        "resetRoutine": "0xc159290",
        "saveOffset": 304,
        "saveOffsetHex": "0x130"
      },
      {
        "bank": 3,
        "storage": "bitfield",
        "runtimeAddress": "0xc223ef0",
        "capacity": 64,
        "byteLength": 8,
        "reader": "0xc1590f4",
        "writer": "0xc15911e",
        "initialValue": 0,
        "resetRoutine": "0xc159290",
        "saveOffset": 296,
        "saveOffsetHex": "0x128"
      },
      {
        "bank": 4,
        "storage": "byte array",
        "runtimeAddress": "0xc223f78",
        "capacity": 32,
        "byteLength": 32,
        "reader": "0xc159154",
        "writer": "0xc159168",
        "initialValue": 0,
        "resetRoutine": "0xc159290",
        "saveOffset": 560,
        "saveOffsetHex": "0x230"
      }
    ]
  },
  "actorRuntimeValues": {
    "identityTableAddress": "0xc278d08",
    "identityTableCount": 301,
    "zeroIdentityRule": "use current conversation actor identity",
    "nonzeroIdentityRule": "use the encoded value as an index into fixedIdentities",
    "runtimeFieldOffset": "0x90",
    "runtimeFieldQuery": "0xc119888",
    "runtimeFieldProducer": {
      "descriptorOperation": "0xf",
      "handler": "0xc119622",
      "effect": "copy the descriptor dword at +4 to actor runtime +0x90"
    },
    "numericMeaningPolicy": "retain authored integer values until individual script consumers prove semantic labels"
  },
  "spatialTable": {
    "comparison": "current map identity equals record map identity and (playerX-centerX)^2 + (playerZ-centerZ)^2 < radiusSquared",
    "boundaryRule": "strictly inside; the radius boundary is false",
    "records": [
      {
        "index": 1,
        "mapIdentity": "D000",
        "runtimePosition": [
          6.0,
          0.0,
          84.0
        ],
        "browserPosition": [
          -6.0,
          0.0,
          84.0
        ],
        "radiusSquared": 225.0,
        "radius": 15.0
      },
      {
        "index": 2,
        "mapIdentity": "D000",
        "runtimePosition": [
          12.0,
          0.0,
          46.0
        ],
        "browserPosition": [
          -12.0,
          0.0,
          46.0
        ],
        "radiusSquared": 196.0,
        "radius": 14.0
      },
      {
        "index": 3,
        "mapIdentity": "D000",
        "runtimePosition": [
          -127.0,
          0.0,
          70.0
        ],
        "browserPosition": [
          127.0,
          0.0,
          70.0
        ],
        "radiusSquared": 400.0,
        "radius": 20.0
      },
      {
        "index": 4,
        "mapIdentity": "D000",
        "runtimePosition": [
          -20.0,
          0.0,
          72.0
        ],
        "browserPosition": [
          20.0,
          0.0,
          72.0
        ],
        "radiusSquared": 225.0,
        "radius": 15.0
      },
      {
        "index": 5,
        "mapIdentity": "D000",
        "runtimePosition": [
          -14.0,
          0.0,
          28.0
        ],
        "browserPosition": [
          14.0,
          0.0,
          28.0
        ],
        "radiusSquared": 225.0,
        "radius": 15.0
      },
      {
        "index": 6,
        "mapIdentity": "D000",
        "runtimePosition": [
          -103.0,
          0.0,
          98.0
        ],
        "browserPosition": [
          103.0,
          0.0,
          98.0
        ],
        "radiusSquared": 100.0,
        "radius": 10.0
      },
      {
        "index": 7,
        "mapIdentity": "D000",
        "runtimePosition": [
          -41.0,
          0.0,
          75.0
        ],
        "browserPosition": [
          41.0,
          0.0,
          75.0
        ],
        "radiusSquared": 225.0,
        "radius": 15.0
      },
      {
        "index": 8,
        "mapIdentity": "D000",
        "runtimePosition": [
          38.0,
          0.0,
          10.0
        ],
        "browserPosition": [
          -38.0,
          0.0,
          10.0
        ],
        "radiusSquared": 225.0,
        "radius": 15.0
      },
      {
        "index": 9,
        "mapIdentity": "D000",
        "runtimePosition": [
          -57.0,
          0.0,
          44.0
        ],
        "browserPosition": [
          57.0,
          0.0,
          44.0
        ],
        "radiusSquared": 225.0,
        "radius": 15.0
      },
      {
        "index": 10,
        "mapIdentity": "D000",
        "runtimePosition": [
          22.0,
          0.0,
          36.0
        ],
        "browserPosition": [
          -22.0,
          0.0,
          36.0
        ],
        "radiusSquared": 225.0,
        "radius": 15.0
      },
      {
        "index": 11,
        "mapIdentity": "MFSY",
        "runtimePosition": [
          14.0,
          0.0,
          142.0
        ],
        "browserPosition": [
          -14.0,
          0.0,
          142.0
        ],
        "radiusSquared": 1225.0,
        "radius": 35.0
      },
      {
        "index": 12,
        "mapIdentity": "MFSY",
        "runtimePosition": [
          -30.0,
          0.0,
          91.0
        ],
        "browserPosition": [
          30.0,
          0.0,
          91.0
        ],
        "radiusSquared": 1225.0,
        "radius": 35.0
      },
      {
        "index": 13,
        "mapIdentity": "MFSY",
        "runtimePosition": [
          124.0,
          0.0,
          51.0
        ],
        "browserPosition": [
          -124.0,
          0.0,
          51.0
        ],
        "radiusSquared": 400.0,
        "radius": 20.0
      }
    ]
  },
  "operators": {
    "0": "terminate",
    "1": "assign",
    "2": "increment",
    "3": "decrement",
    "4": "isZero",
    "5": "booleanAnd",
    "6": "booleanOr",
    "7": "equal",
    "8": "notEqual",
    "9": "greaterThan",
    "10": "greaterThanOrEqual",
    "11": "lessThan",
    "12": "lessThanOrEqual"
  }
});
